export const PUSH_TO_DIGITAL_MAGAZINE_MENU = 'DigitalMagazine/PUSH_TO_MENU'
